import { render, staticRenderFns } from "./uploadImgSpaceup.vue?vue&type=template&id=75abe269&scoped=true"
import script from "./uploadImgSpaceup.vue?vue&type=script&lang=js"
export * from "./uploadImgSpaceup.vue?vue&type=script&lang=js"
import style0 from "./uploadImgSpaceup.vue?vue&type=style&index=0&id=75abe269&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75abe269",
  null
  
)

export default component.exports